<div class="projected-outcomes-page col-md-6">
  <div class="glass-card projected-card p-3 p-md-4 h-100">

    <!-- Header -->
    <div class="d-flex align-items-start justify-content-between mb-3 po-header">
      <div class="d-flex align-items-center gap-2">
        <i :class="ui_config.header_icon_class" class="text-warning opacity-75"></i>

        <div class="d-flex flex-column">
          <div class="text-white fw-semibold lh-1 small">
            {{ ui_labels.card_title }}
          </div>
          <div class="text-white-50 small">
            Live results from your inputs
          </div>
        </div>
      </div>

      <!-- Top-right exchange rate card (Desktop) -->
      <div class="d-none d-md-block po-exchange-card">
        <ExchangeRateCard
          :title="ui_labels.exchange_rate_title || 'EXCHANGE RATE'"
          :subtext="ui_labels.exchange_rate_subtext || 'per verified job'"
          :value="outcomes.exchange_rate || 'R0'"
        />
      </div>
    </div>

    <!-- Top-right exchange rate card (Mobile) -->
    <div class="d-block d-md-none mb-3 po-exchange-card">
      <ExchangeRateCard
        :title="ui_labels.exchange_rate_title || 'EXCHANGE RATE'"
        :value="outcomes.exchange_rate || outcomes.cost_per_job || 'R0'"
        :subtext="ui_labels.exchange_rate_subtext || 'per verified job'"
      />
    </div>

    <!-- Outcome cards -->
    <div class="row g-2 g-md-3 mb-3 po-grid">

      <!-- Assets -->
      <div class="col-4">
        <div class="outcome-box po-box rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.assets_icon" class="text-danger opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.assets }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.assets }}</div>
        </div>
      </div>

      <!-- Jobs Expected -->
      <div class="col-4">
        <div class="outcome-box po-box rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.jobs_expected_icon" class="text-primary opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.jobs_expected }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.jobs_expected }}</div>
        </div>
      </div>

      <!-- Jobs Verified -->
      <div class="col-4">
        <div class="outcome-box po-box po-box-emphasis rounded-3 border border-warning border-opacity-50 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.jobs_verified_icon" class="text-success opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.jobs_verified }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.jobs_verified }}</div>
        </div>
      </div>

      <!-- Revenue -->
      <div class="col-4">
        <div class="outcome-box po-box rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.revenue_icon" class="text-info opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.revenue }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.revenue }}</div>
        </div>
      </div>

      <!-- Recycled -->
      <div class="col-4">
        <div class="outcome-box po-box rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.recycled_icon" class="text-success opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.recycled }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.recycled }}</div>
        </div>
      </div>

      <!-- Bonus -->
      <div class="col-4">
        <div class="outcome-box po-box rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 h-100">
          <div class="d-flex align-items-center gap-2 mb-2">
            <i :class="ui_config.bonus_icon" class="text-warning opacity-75"></i>
            <div class="text-white-50 small fw-semibold text-truncate">
              {{ ui_labels.bonus }}
            </div>
          </div>
          <div class="text-white fw-bold small">{{ outcomes.bonus }}</div>
        </div>
      </div>

    </div>

    <!-- Summary strip -->
    <div class="rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 mb-3 po-strip">
      <div class="row g-2 text-center">

        <div class="col-4">
          <div class="text-success fw-bold small">{{ outcomes.survival_rate }}</div>
          <div class="text-white-50 small">{{ ui_labels.survival }}</div>
        </div>

        <div class="col-4">
          <div class="text-warning fw-bold small">{{ outcomes.cost_per_job }}</div>
          <div class="text-white-50 small">{{ ui_labels.cost_job }}</div>
        </div>

        <div class="col-4">
          <div class="text-primary fw-bold small">{{ outcomes.break_even_period }}</div>
          <div class="text-white-50 small">{{ ui_labels.break_even }}</div>
        </div>

      </div>
    </div>

    <!-- Chart section -->
    <div class="po-chart-section">
      <label class="form-label text-white-50 small fw-semibold mb-2">
        {{ ui_labels.chart_title }}
      </label>

      <div class="rounded-3 border border-secondary border-opacity-25 p-2 p-md-3 po-chart">
        <svg width="100%" height="120" viewBox="0 0 400 120" class="d-block po-svg">
          <path class="po-line po-line-main" d="M0,80 Q100,75 200,60 T400,30" fill="none" />
          <path class="po-line po-line-guide" d="M0,80 Q100,78 200,65 T400,35" fill="none" stroke-dasharray="4,2" />

          <text class="po-tick" x="0" y="115" font-size="10">Sep</text>
          <text class="po-tick" x="100" y="115" font-size="10">Oct</text>
          <text class="po-tick" x="200" y="115" font-size="10">Nov</text>
          <text class="po-tick" x="300" y="115" font-size="10">Dec</text>
          <text class="po-tick" x="380" y="115" font-size="10">Jan</text>
        </svg>
      </div>
    </div>

  </div>
</div>